import React, { useEffect, useRef, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { applyMenuTemplate } from "src/helpers/applyTemplate";
import { classNames } from "src/helpers/classNames";
import useDevice from "src/hooks/useDevice";

export default function CustomHtmlMenu({ menus = [], template, sidepanelWidth, isMenu }) {
  const device = useDevice();
  const navigate = useNavigate();
  const location = useLocation();
  const iframeRef = useRef();

  const currentUrl = location.pathname + location.search;


  // eslint-disable-next-line react-hooks/exhaustive-deps
  const finalHtml = useMemo(() => applyMenuTemplate(template, menus, currentUrl), [template, menus]);

  useEffect(() => {
    if (!iframeRef.current) return;
    const doc = iframeRef.current.contentDocument;
    if (!doc) return;

    doc.open();
    doc.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <script src="https://cdn.tailwindcss.com"></script>
        <style>
          html, body {
            margin: 0;
            padding: 0;
            height: 100%;
            width: 100%;
            overflow: hidden;
            background: transparent;
          }
        </style>
      </head>
      <body>
        ${finalHtml}
      </body>
    </html>
  `);
    doc.close();
  }, [finalHtml]);

  useEffect(() => {
    const handler = (e) => {
      if (e.data?.type === "NAVIGATE") {
        const link = e.data?.link;
        if (link && link !== "#") navigate(link);
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [navigate]);

  const width = device === "desktop" ? sidepanelWidth : 310;

  return (
    <div
      className={classNames("fixed left-0 top-0 z-[49] h-full bg-black transition-all duration-200 xl:z-[39]", isMenu ? "visible opacity-80" : "invisible opacity-0")}
      style={{ width }}>
      <iframe
        title="sidebar-iframe"
        ref={iframeRef}
        style={{ width: "100%", height: "100%", border: "none" }}
        sandbox="allow-same-origin allow-scripts"
      />
    </div>
  );
}
